import { render, staticRenderFns } from "./ChatQueue.vue?vue&type=template&id=255930b4&scoped=true&"
import script from "./ChatQueue.vue?vue&type=script&lang=js&"
export * from "./ChatQueue.vue?vue&type=script&lang=js&"
import style0 from "./ChatQueue.vue?vue&type=style&index=0&id=255930b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255930b4",
  null
  
)

export default component.exports